import { asScaled } from '../utils';
const animatedTabLayout = {
    // 间距
    spacing: 30,
    // 容器内边距
    paddingHorizontal: 20,
    // 高度
    height: 48,
    // 条目下部滑块
    widgetHeight: 8,
    widgetBottom: 13,
    widgetExpandMargin: 4,
    // 遮罩宽度
    maskWidth: 20,
    // 更多按钮宽度
    moreWidth: 60
};
const animatedTabLayoutScaled = asScaled(animatedTabLayout);
export const animatedTab = {
    scaled: animatedTabLayoutScaled,
    unscaled: animatedTabLayout
};
